// Users API service
import { apiService } from './api';
import { User, UserCreate, UserUpdate, Facility, PaginationParams } from '../types';

export class UsersService {
  async getUsers(params?: PaginationParams): Promise<User[]> {
    return apiService.get<User[]>('/users/', params);
  }

  async getUserById(id: string): Promise<User> {
    return apiService.get<User>(`/users/${id}`);
  }

  async createUser(userData: UserCreate): Promise<User> {
    return apiService.post<User>('/users/', userData);
  }

  async updateUser(id: string, userData: UserUpdate): Promise<User> {
    return apiService.put<User>(`/users/${id}`, userData);
  }

  async deleteUser(id: string): Promise<void> {
    return apiService.delete<void>(`/users/${id}`);
  }

  async getUserFacilities(
    userId: string,
    params?: PaginationParams
  ): Promise<Facility[]> {
    return apiService.get<Facility[]>(`/users/${userId}/facilities`, params);
  }
}

export const usersService = new UsersService();
